import WebhookSubscriptionsPage from '../pages/dashboard/components/pages/webhooks/WebhookSubscriptionsPage';
export default function WebhooksRoute() { return <WebhookSubscriptionsPage />; }
